import { Component, Inject } from '@angular/core';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { CloseOnEscapeDirective } from '../../shared/directives/close-on-escape.directive';

export type AlertType = 'success' | 'error' | 'warning' | 'info';

export interface AlertDialogData {
  title?: string;
  message?: string;
  text?: string;
  type?: AlertType;
  icon?: AlertType;
  confirmButtonText?: string;

  showCancelButton?: boolean;
  cancelButtonText?: string;
}

@Component({
  selector: 'app-alert-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, TranslocoModule, CloseOnEscapeDirective],
  templateUrl: '../templates/alert-dialog.component.html',
  styleUrl: '../templates/styles/alert-dialog.component.css',
})
export class AlertDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlertDialogData
  ) {}

  get message(): string {
    return this.data.message ?? this.data.text ?? '';
  }

  get type(): AlertType {
    return this.data.type ?? this.data.icon ?? 'info';
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onCancel();
    }
  }
}
